import { dataIntelligentPrompt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIntelligentPrompt = /*#__PURE__*/createIcon(dataIntelligentPrompt)
export default IconIntelligentPrompt
